// This is the HTTP command, independent of the browser's durable queue owner
// and recovery bookkeeping. Both rich content and the captured epoch survive.
export const messageCommandKeys = ['client_message_id','membership_epoch_id','body','reply_to_message_id','attachment_ids','mentions','entities'] as const;
export function toWireMessageCommand(stored:Record<string,unknown>):Record<string,unknown>{
 return Object.fromEntries(messageCommandKeys.map(key=>[key,stored[key]]));
}
